
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    "search_placeholder": {
        id: 'invoice.listing.search_placeholder',
        defaultMessage: 'Search an invoice...',
    },
    "customer_type_placeholder": {
        id: 'invoice.listing.customer_type_placeholder',
        defaultMessage: 'Customer type',
    },
    "status_filter_placeholder": {
        id: 'invoice.listing.status_filter_placeholder',
        defaultMessage: 'Filter by status',
    },
    "identifier": {
        id: "invoice.listing.headers.id_label",
        defaultMessage: 'ID'
    },
    "due_date": {
        id: 'invoice.listing.filters.date.due_date',
        defaultMessage: 'Due date',
    },
    "last_payment_at": {
        id: 'invoice.listing.filters.date.last_payment_at',
        defaultMessage: 'Last payment date',
    },
    "effective_date": {
        id: 'invoice.listing.filters.date.effective_date',
        defaultMessage: 'Effective date',
    },
    "fully_paid_at": {
        id: 'invoice.listing.filters.date.fully_paid_at',
        defaultMessage: 'Fully paid date',
    },
    "created_at": {
        id: 'invoice.listing.filters.date.created_at',
        defaultMessage: 'Created date',
    },
    "updated_at": {
        id: 'invoice.listing.filters.date.updated_at',
        defaultMessage: 'Updated date',
    },
    "contact_nameSort": {
        id: "invoice.listing.headers.contact_nameSort",
        defaultMessage: "Contact",
    },
    "status": {
        id: "invoice.listing.headers.status_label",
        defaultMessage: "Status",
    },
    "total_amount": {
        id: "invoice.listing.headers.total_amount",
        defaultMessage: "Amount",
    },
    "balance": {
        id: "invoice.listing.headers.balance_label",
        defaultMessage: "Balance",
    },
    "poNumber": {
        id: "invoice.listing.headers.po_number",
        defaultMessage: "Po Number",
    },
    "sellerId": {
        id: "invoice.listing.headers.seller_id",
        defaultMessage: "User id",
    },
    "location": {
        id: "invoice.listing.headers.location",
        defaultMessage: "Location",
    },
    "imported_at": {
        id: "invoice.listing.headers.imported_at",
        defaultMessage: "Imported at date",
    },
    "contact_firstname": {
        id: "invoice.listing.headers.contact_firstname",
        defaultMessage: "Contact first name",
    },
    "contact_lastname": {
        id: "invoice.listing.headers.contact_lastname",
        defaultMessage: "Contact last name",
    },
    "contact_organization_name": {
        id: "invoice.listing.headers.contact_organization_name",
        defaultMessage: "Contact organization name",
    },
    "contact_type": {
        id: "invoice.listing.headers.contact_type",
        defaultMessage: "Contact type",
    },
    "contact_phonenumber": {
        id: "invoice.listing.headers.contact_phonenumber",
        defaultMessage: "Contact phone number",
    },
    "contact_email": {
        id: "invoice.listing.headers.contact_email",
        defaultMessage: "Contact email",
    },
    "contact_name": {
        id: "invoice.listing.headers.contact_name",
        defaultMessage: "Contact name",
    },
    "contact_id": {
        id: "invoice.listing.headers.contact_id",
        defaultMessage: "Contact id",
    },
    "sent_at": {
        id: "invoice.listing.headers.sent_at",
        defaultMessage: "Sent at date",
    },
    "voided_at": {
        id: "invoice.listing.headers.voided_at",
        defaultMessage: "Voided at date",
    },
    "paid_amount": {
        id: "invoice.listing.headers.paid_amount",
        defaultMessage: "Paid amount",
    },
    "currency": {
        id: "invoice.listing.headers.currency",
        defaultMessage: "Currency",
    },
    "tax_id": {
        id: "invoice.listing.headers.tax_id",
        defaultMessage: "Tax",
    },
    "payment_transaction_payment_type": {
        id: "invoice.listing.headers.payment_transaction_payment_type",
        defaultMessage: "Type of payment",
    },
    "payment_transaction_payment_amount": {
        id: "invoice.listing.headers.payment_transaction_payment_amount",
        defaultMessage: "Payment Transaction amount",
    },
    "invoice_id": {
        id: "invoice.listing.headers.invoice_id",
        defaultMessage: "Invoice id",
    },
    "payment_term": {
        id: "invoice.listing.headers.payment_term",
        defaultMessage: "Payment term",
    },
    "project_id": {
        id: "invoice.listing.headers.project_id",
        defaultMessage: "Contact organization name",
    },
    "external_links_integration_key": {
        id: "invoice.listing.headers.external_links_integration_key",
        defaultMessage: "External links integration",
    },
    "external_links_external_id": {
        id: "invoice.listing.headers.external_links_external_id",
        defaultMessage: "External links id",
    },
    "product_id": {
        id: "invoice.listing.headers.product_id",
        defaultMessage: "Product",
    },
    "product_label": {
        id: "invoice.listing.headers.product_label",
        defaultMessage: "Product label",
    },
    "product_title": {
        id: "invoice.listing.headers.product_title",
        defaultMessage: "Product title",
    },
    "product_sku": {
        id: "invoice.listing.headers.product_sku",
        defaultMessage: "Product sku",
    },
    "interval_type": {
        id: "subscription.listing.headers.interval_type",
        defaultMessage: "Interval type",
    },
    "start_date": {
        id: "subscription.listing.headers.start_date",
        defaultMessage: "Start date",
    },
    "end_date": {
        id: "subscription.listing.headers.end_date",
        defaultMessage: "End date",
    },
    "last_due_date": {
        id: "subscription.listing.headers.last_due_date",
        defaultMessage: "Last due date",
    },
    "next_creation_date": {
        id: "subscription.listing.headers.next_creation_date",
        defaultMessage: "Next creation date",
    },
    "next_due_date": {
        id: "subscription.listing.headers.next_due_date",
        defaultMessage: "Next due date",
    },
    "send_email": {
        id: "subscription.listing.headers.send_email",
        defaultMessage: "Send email",
    },
    "capture_payment": {
        id: "subscription.listing.headers.capture_payment",
        defaultMessage: "Capture payment",
    },
    "created_invoice_count": {
        id: "subscription.listing.headers.created_invoice_count",
        defaultMessage: "Created invoice count",
    },
    "most_used_filters": {
        id: "invoice.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
    "date_related_filters": {
        id: "invoice.listing.headers.date_related_filters",
        defaultMessage: "Date related filters",
    },
    "contact_related_filters": {
        id: "invoice.listing.headers.contact_related_filters",
        defaultMessage: "Contact related filters",
    },
    "payment_related_filters": {
        id: "invoice.listing.headers.payment_related_filters",
        defaultMessage: "Payment related filters",
    },
    "product_related_filters": {
        id: "invoice.listing.headers.product_related_filters",
        defaultMessage: "Product related filters",
    },
})

export const subscriptionTotals = [
    'baseCurrencyTotalAmount',
]

export const subscriptionFields = [
    'identifier',
    'identifierAnalyzed',
    'identifierNumber',
    'identifierKeyword',
    'contact.name',
    'contact.nameAnalyzed',
    'contact.nameKeyword',
]

export const getSubscriptionFilters = function (context) {

    return (
        [
            {
                section: context.intl.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: 'userId',
                label: context.intl.formatMessage(messages["sellerId"]),
                filterMatch: 'sellerId',
                type: 'select',
                typeOfSelect: 'user-select',
                placeHolder: 'Select User',
                initialValue: '',
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'locationId',
                label: context.intl.formatMessage(messages["location"]),
                filterMatch: 'locationId',
                type: 'select',
                typeOfSelect: 'location-select',
                placeHolder: 'Select Location',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'statuses',
                label: context.intl.formatMessage(messages["status"]),
                type: 'select',
                filterMatch: 'status',
                typeOfSelect: 'recurring-status-select',
                placeHolder: context.intl.formatMessage(messages["status_filter_placeholder"]),
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "poNumber",
                label: context.intl.formatMessage(messages["poNumber"]),
                filterMatch: 'poNumberKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'customerLabelIds',
                label: context.intl.formatMessage(messages["customer_type_placeholder"]),
                filterMatch: 'contact.labelIds',
                type: 'select',
                typeOfSelect: 'label-select',
                multi: false,
                placeHolder: context.intl.formatMessage(messages["customer_type_placeholder"]),
                labelName: "customerTypeId",
                labelType: "customer-type",
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'effectiveDate',
                label: context.intl.formatMessage(messages["effective_date"]),
                filterMatch: 'effectiveDate',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'createdAt',
                label: context.intl.formatMessage(messages["created_at"]),
                filterMatch: 'createdAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'amount',
                label: context.intl.formatMessage(messages["total_amount"]),
                nameField: 'totalAmount',
                filterMatch: 'totalAmount',
                type: 'number',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["date_related_filters"]),
            },
            {
                nameId: 'updatedAt',
                label: context.intl.formatMessage(messages["updated_at"]),
                filterMatch: 'updatedAt',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["contact_related_filters"]),
            },
            {
                nameId: 'contactId',
                label: context.intl.formatMessage(messages["contact_id"]),
                filterMatch: 'contactId',
                type: 'select',
                typeOfSelect: 'customer-select',
                initialValue: "",
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'name',
                label: context.intl.formatMessage(messages["contact_name"]),
                filterMatch: 'contact.name',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'firstName',
                label: context.intl.formatMessage(messages["contact_firstname"]),
                filterMatch: 'contact.firstName',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'lastName',
                label: context.intl.formatMessage(messages["contact_lastname"]),
                filterMatch: 'contact.lastName',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'organizationName',
                label: context.intl.formatMessage(messages["contact_organization_name"]),
                filterMatch: 'contact.organizationNameKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'contactType',
                label: context.intl.formatMessage(messages["contact_type"]),
                filterMatch: 'contact.type',
                type: 'select',
                typeOfSelect: 'contactType-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'phoneNumber',
                label: context.intl.formatMessage(messages["contact_phonenumber"]),
                filterMatch: 'contact.phoneNumberKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'email',
                label: context.intl.formatMessage(messages["contact_email"]),
                filterMatch: 'contact.emailKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["payment_related_filters"]),
            },
            {
                nameId: 'currency',
                label: context.intl.formatMessage(messages["currency"]),
                filterMatch: 'currency',
                type: 'select',
                typeOfSelect: 'currency-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: 'taxID',
                label: context.intl.formatMessage(messages["tax_id"]),
                filterMatch: 'taxId',
                type: 'select',
                initialValue: [],
                typeOfSelect: 'tax-select',
                initialSelect: 'isOneOf'
            },
            {
                nameId: "paymentTermId",
                label: context.intl.formatMessage(messages["payment_term"]),
                filterMatch: 'paymentTermId',
                type: 'select',
                typeOfSelect: "paymentTerm-select",
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "projectId",
                label: context.intl.formatMessage(messages["project_id"]),
                filterMatch: 'projectIdKeyword',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                section: context.intl.formatMessage(messages["product_related_filters"]),
            },
            {
                nameId: "productId",
                label: context.intl.formatMessage(messages["product_id"]),
                filterMatch: 'rows.id',
                filterMatchNotOneOf: 'rowsObject.id',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'product-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                nameId: "productTitle",
                label: context.intl.formatMessage(messages["product_title"]),
                filterMatch: 'rows.title',
                filterMatchNot: 'rowsObject.title',
                type: 'text',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "productSku",
                label: context.intl.formatMessage(messages["product_sku"]),
                filterMatch: 'rows.sku',
                filterMatchNot: 'rowsObject.sku',
                type: 'text',
                subtype: 'nested',
                initialValue: '',
                initialSelect: 'is'
            },
            {

                nameId: "productLabel",
                label: context.intl.formatMessage(messages["product_label"]),
                filterMatch: 'rows.labelIds',
                filterMatchNotOneOf: 'rowsObject.labelIds',
                type: 'select',
                subtype: 'nested',
                typeOfSelect: 'product-label-select',
                initialValue: [],
                initialSelect: 'isOneOf'
            },
            {
                section: 'Recurring Information',
            },
            {
                nameId: "capturePayment",
                label: context.intl.formatMessage(messages["capture_payment"]),
                filterMatch: 'capturePayment',
                type: 'boolean',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "sendEmail",
                label: context.intl.formatMessage(messages["send_email"]),
                filterMatch: 'sendEmail',
                type: 'boolean',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: 'nextDueDate',
                label: context.intl.formatMessage(messages["next_due_date"]),
                filterMatch: 'nextDueDate',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'nextCreationDate',
                label: context.intl.formatMessage(messages["next_creation_date"]),
                filterMatch: 'nextCreationDate',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'lastDueDate',
                label: context.intl.formatMessage(messages["last_due_date"]),
                filterMatch: 'lastDueDate',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'endDate',
                label: context.intl.formatMessage(messages["end_date"]),
                filterMatch: 'endDate',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: 'startDate',
                label: context.intl.formatMessage(messages["start_date"]),
                filterMatch: 'startDate',
                type: 'date',
                initialValue: { startDate: null, endDate: null },
                initialSelect: 'is'
            },
            {
                nameId: "intervalType",
                label: context.intl.formatMessage(messages["interval_type"]),
                filterMatch: 'intervalType',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "createdInvoiceCount",
                label: context.intl.formatMessage(messages["created_invoice_count"]),
                filterMatch: 'createdInvoiceCount',
                type: 'number',
                initialValue: '',
                initialSelect: 'is'
            },
            {
                nameId: "identifier",
                label: context.intl.formatMessage(messages["identifier"]),
                filterMatch: 'identifier',
                type: 'text',
                initialValue: '',
                initialSelect: 'is'
            },
        ]
    )
}



// WEBPACK FOOTER //
// ./src/common/search-filter/search/subscriptionFilters.jsx